import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MessageService, TreeNode } from 'primeng/api';
import { GenericService } from 'src/app/services/generic.service';
import { Message } from 'primeng/api';

declare var window: any;

interface Tree {
  key: string;
  label: string;
  data: string;
  icon: string;
  children?: TreeNode[];
  clientDocsId: number;
  fileType: string;
  fileTypeExtension: string;
  id: string;
  keyValues?: Tree[];
  name: string;
  value: string;
}

@Component({
  selector: 'app-client-doc',
  templateUrl: './client-doc.component.html',
  styleUrls: ['./client-doc.component.css']
})
export class ClientDocComponent implements OnInit {

  cid: any
  userId: any
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 100;
  tableSize: number = 10;

  fileName: any = ""
  folderName: any = ""
  tagName: any = [
    {
      "name": ""
    }
  ]
  value: any = ""
  clientDocsList: any = []
  branchList: any = []
  branchId: any;
  parentFolderId: any = ""
  clientDocsId: any = ""
  // rightClientDocsId: any = ""
  // rightParentFolderId: any = ""
  requestFolderOrFileId: any = ""
  requestClientDocsId: any = ""
  folderOrFileName: any = ""
  singleclientDocData: any = []
  folderHierarchy: any = []
  isFolderHierarchy: any = false
  type: any = "";
  file: any;
  fileTypeExtension: any = ""

  folderPath: any = []
  formModal: any
  menuOptionsType = ""
  fileOrFolderName = ""
  data: any;
  convertedData: any[] = [];

  isCopied: any = false;
  copiedData: any = []
  rightClickedData: any
  leftClickedData: any

  isMove: any = false;
  moveData: any = []

  openSpaceVisible: any = false
  leftMenuVisible: any = false
  clickType: any = ""
  rightSideClick: any = false
  leftSideClick: any = false
  openSpaceClick: any = false
  moveFromId: any =  ""
  moveToId: any =  ""
  copyFromId: any =  ""
  copyToId: any =  ""
  toClientDocsId: any
  uploadingList: any = []
  messages: any = [];
  access: any = [];
  isShowAccess: any = false;
  isLoading: any = false;
  companyData: any = []
  locationData: any = []
  industryData: any = []
  list: any

  metaData: any = [
    {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": 0,
      "name": "",
      "value": ""
    }
  ]

  constructor(
    private elementRef: ElementRef,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.userId = sessionStorage.getItem('userId')

    // this.getAllClientDocs(this.pageNumber,this.recordsPerPage)
    this.allClientDocsAtZeroLevel()
    this.getAllCompanyProfileWithoutPagination()
    this.getAllLocation()
    this.getAllIndustry()
  }


  addTagName(){
    this.tagName.push(
      {
        "name": "",
      }
    )
  }

  removeTagName(index:any){
    this.tagName.splice(index,1)
  }



  addMetaData(){
    this.metaData.push(
      {
        "version": 0,
        "isActive": true,
        "description": "",
        "id": 0,
        "name": "",
        "value": ""
      }
    )
  }

  removeMetaData(index:any){
    this.metaData.splice(index,1)
  }

  createButtonClicked(){
    // this.fileName = "folder " + Number(this.clientDocsList[0].keyValues.length+1)
    // this.folderName = "folder " + Number(this.clientDocsList[0].keyValues.length+1)
    this.type = "folder"

  }

  folderHome(){
    // this.getAllClientDocs(this.pageNumber,this.recordsPerPage)
    this.allClientDocsAtZeroLevel()
    this.clientDocsId = ""
    this.parentFolderId = ""
    this.structureType = ""
    this.peresentStructureType = ""
    this.isFolderHierarchy = false
    this.folderPath = []
  }

  fileData: any = []

  fileOpen(fileData: any){
    console.log(fileData)

    this.fileData = []
    this.fileData.push(fileData)
  }

  clickFolderOrFile(){

  }

  addFolderOrFile(obj: any){
    // this.clientDocsList[0].keyValues.push(
    //   {
    //     "name": this.fileName,
    //     "value": "",
    //     "fileType": "folder",
    //     "keyValues": []
    //   }
    // )
    // document.getElementById("closeModalButton1")?.click()

    let tagName: any = []

    for(let list of this.tagName){
      tagName.push(list.name)
    }


    let file = {
      "clientDocsId": this.clientDocsId,
      "cid": Number(this.cid),
      "parentFolderId": this.parentFolderId,
      "name": obj.fileName,
      "value": obj.value,
      "fileType": "File",
      "structureType": this.structureType,
      "fileTypeExtension": obj.fileTypeExtension,
      "createdBy": sessionStorage.getItem('userName'),
      "createdDate": new Date().getTime(),
      "active": true,
      "access": {
        "validFrom": new Date().getTime(),
        "id": Number(this.userId),
        "validTo": 4102358400000,
        "name": sessionStorage.getItem('userName')
      },

      "metaData": this.metaData,
          "tagName": tagName,
          "statusObj": [
            {
              "status": "CREATED",
              "userId": Number(this.userId),
              "userName": sessionStorage.getItem('userName'),
              "createdOn": new Date().getTime(),
            }
          ],
          "latestStatus": {
            "status": "CREATED",
            "userId": Number(this.userId),
            "userName": sessionStorage.getItem('userName'),
            "createdOn": new Date().getTime(),
          },
      "tagged": true,
    }

    let folder = {
      "clientDocsId": this.clientDocsId,
      "cid": Number(this.cid),
      "parentFolderId": this.parentFolderId,
      "name": this.folderName,
      "value": "",
      "fileType": "Folder",
      "fileTypeExtension": "",
      "structureType": this.structureType,
      "createdBy": sessionStorage.getItem('userName'),
      "createdDate": new Date().getTime(),
      "active": true,
      "access": {
        "validFrom": new Date().getTime(),
        "id": Number(this.userId),
        "validTo": 4102358400000,
        "name": sessionStorage.getItem('userName')
      },
      "metaData": this.metaData,
          "tagName": tagName,
          "statusObj": [
            {
              "status": "CREATED",
              "userId": Number(this.userId),
              "userName": sessionStorage.getItem('userName'),
              "createdOn": new Date().getTime(),
            }
          ],
          "latestStatus": {
            "status": "CREATED",
            "userId": Number(this.userId),
            "userName": sessionStorage.getItem('userName'),
            "createdOn": new Date().getTime(),
          },
      "tagged": true,
    }

    let body: any


    if(this.type == "folder"){
      if(this.folderName == null || this.folderName == undefined || this.folderName == ""){
        this.toastr.error('Folder name required')
        return
      }
      body = folder
    }

    if(this.type == "file"){
      body = file
    }

    console.log(body)
    this.generic_service.addFiles(body).subscribe(
      (response:any) => {
        console.log(response)
        document.getElementById("closeModalButton1")?.click()
        this.modalClose()
        let uploadData:any = []
        for(let list of this.uploadingList){
          if(list.detail == body.name){
            list.severity = "success"
            list.isUpload = true
          }
          uploadData.push(list)
        }
        this.messages = []

        this.messages = uploadData
        this.uploadingList = uploadData
        console.log(this.uploadingList)

        if(this.type == "folder"){
        this.toastr.success('Folder Created')

          this.reload()
        }
        if(this.type == "file"){
          this.reload()
        }
        this.folderName = ""
        this.structureType = ""

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelMetaTags(){

    this.metaData = []

    this.metaData = [
      {
        "version": 0,
        "isActive": true,
        "description": "",
        "id": 0,
        "name": "",
        "value": ""
      }
    ]

    this.tagName = [
      {
        "name": ""
      }
    ]
  }

  modalClose(){
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton11")?.click()
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  reload(){
    // this.getFolderHierarchyByParentFolderId(this.list)
    this.getFolderHierarchyByParentFolderIdAfterPost(this.parentFolderId,this.clientDocsId)
    // this.refreshFolder(this.pageNumber,this.recordsPerPage)
    this.getFolderPathForGivenFolder(this.parentFolderId,this.clientDocsId)
    this.modalClose()
    console.log('reload')
  }

  checkFolderName(folderName: any){
    let count = 0
    let name: any

    for(let list of this.folderHierarchy){
      if(list.name == folderName){
        count += 1
      }
    }

    if(count != 0){
      name = folderName+' '+ count
    }else{
      name = folderName
    }

    let isName = false
    if(count != 0){
      for(let list of this.folderHierarchy){
        if(list.name == name){
          isName = true
        }
      }
    }


    if(!isName){
      console.log(name)

      this.folderName = name
    }else{
      this.checkFolderName(name)
      isName = false
    }
  }


  addDoc(){

    let tagName: any = []

    for(let list of this.tagName){
      tagName.push(list.name)
    }


    const body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "clientName": "",
      "keyValues": [
        {
          "name": this.folderName,
          "value": "",
          "id": 1,
          "keyValues": [],
          "fileType": "Folder",
          "structureType": this.structureType,
          "createdBy": sessionStorage.getItem('userName'),
          "createdDate": new Date().getTime(),
          "active": true,
          "expiryDate": 0,
          "access": {
            [this.userId]: {
              "validFrom": new Date().getTime(),
              "validTo": 4102358400000,
              "name": sessionStorage.getItem('userName')
            }
          },
          "fileTypeExtension": "",
          "metaData": this.metaData,
          "tagName": tagName,
          "statusObj": [
            {
              "status": "CREATED",
              "userId": Number(this.userId),
              "userName": sessionStorage.getItem('userName'),
              "createdOn": new Date().getTime(),
            }
          ],
          "latestStatus": {
            "status": "CREATED",
            "userId": Number(this.userId),
            "userName": sessionStorage.getItem('userName'),
            "createdOn": new Date().getTime(),
          }
        },
      ],
      "branchId": 0,
      "cid": Number(this.cid),








    }



    // console.log(body)
    if(this.parentFolderId == ''){
      if(this.folderName != null && this.folderName != undefined && this.folderName != ""){
        this.generic_service.addClientDocs(body).subscribe(
          (response:any) => {
            console.log(response)
            this.folderName = ""
            // this.getAllClientDocs(this.pageNumber,this.recordsPerPage)
            this.allClientDocsAtZeroLevel()
            this.toastr.success('Folder Created')
            
            document.getElementById("closeModalButton1")?.click()
            this.modalClose()

            // this.refreshFolder(this.pageNumber,this.recordsPerPage)
            this.structureType = ""
          },
          (error:any)=>{
            console.log(error)
          }
        )
      }else{
        this.toastr.error('Folder name required')
      }

    }else{
      let obj = {
        value: "",
        fileName: "",
        fileTypeExtension: ""
      }
      this.addFolderOrFile(obj)
    }

  }


  // getAllClientDocs(pageNumber:any,recordsPerPage:any){
  //   this.generic_service.getAllClientDocs(pageNumber,recordsPerPage).subscribe(
  //     (response:any)=>{
  //       console.log(response);
  //       this.clientDocsList = response.response.clientDocsList;
  //       this.totalRecords = response.response.totalRecords;



  //       let folder: any = []
  //       for(let list of response.response.clientDocsList){
  //         list.keyValues[0].clientDocsId = list.clientDocsId
  //         console.log(list)
  //         folder.push(list.keyValues[0])
  //       }

  //       let menus: any = []
  //       for(let list of folder){
  //         let obj: any = {
  //           clientDocsId: list.clientDocsId,
  //           id: list.id,
  //           name: list.name,
  //           value: list.value,
  //           fileType: list.fileType,
  //           fileTypeExtension: list.fileTypeExtension,
  //           keyValues: list.keyValues
  //         }
  //         menus.push(obj)
  //       }
  //       console.log(folder)
  //       console.log(menus)
  //       this.replaceKeyValuesWithChildren(menus)
  //       console.log(menus)
  //       this.data = menus;


  //       // this.data = this.convertData(menus);
  //       // console.log(this.data)

  //       // this.convertedData = this.convertArray(menus);
  //       // console.log(this.convertedData);

  //       // this.data = this.convertedData;
  //       // console.log(this.data)


  //     }
  //   )
  // }





  replaceKeyValuesWithChildren(data: any) {
    data.forEach((item: any) => {
        // Replace keyValues with children
        if (item.keyValues == null || item.keyValues == undefined) {
          item.keyValues = []
        }
        for(let list of item.keyValues){
          list.clientDocsId = item.clientDocsId
        }
        let icon: any = ""
        let fileTypeExtension: any = item.fileTypeExtension
        let image = "bi bi-image"
        let folder = "bi bi-folder-fill"
        let pdf = "bi bi-file-earmark-pdf"
        let csv = "bi bi-filetype-csv"
        let docx = "bi bi-filetype-docx"
        let json = "bi bi-filetype-json"
        let xml = "bi bi-filetype-xml"
        let word = "bi bi-file-word"
        let ppt = "bi bi-file-earmark-ppt"
        let excel = "bi bi-file-earmark-excel"
        let text = "bi bi-file-earmark-text-fill"
        let company = "bi bi-building"
        let location = "bi bi-geo-alt"
        let department = "bi bi-houses"
        if(item.fileType == "Folder"){
          icon = folder
          if(item.structureType != null && item.structureType != undefined){
            if(item.structureType == 'company'){
              icon = company
            }
            if(item.structureType == 'location'){
              icon = location
            }
            if(item.structureType == 'department'){
              icon = department
            }
          }
        }

        if(item.fileType == "File"){
          if(item.fileTypeExtension == "image/jpeg" || item.fileTypeExtension == "image/jpg" || item.fileTypeExtension == "image/png"){
            icon = image
          }
          if(item.fileTypeExtension == "application/pdf"){
            icon = pdf
            fileTypeExtension = "PDF"

          }

          if(item.fileTypeExtension == "text/csv"){
            icon = csv
            fileTypeExtension = "CSV"

          }

          if(item.fileTypeExtension == "application/vnd.openxmlformats-officedocument.wordprocessingml.document"){
            icon = xml
            fileTypeExtension = "Word"

          }

          if(item.fileTypeExtension == "application/vnd.ms-excel"){
            icon = excel
            fileTypeExtension = "Excel"

          }

          if(item.fileTypeExtension == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
            icon = xml
            fileTypeExtension = "Excel"

          }

          if(item.fileTypeExtension == "text/rtf"){
            icon = docx
            fileTypeExtension = "rft"

          }

          if(item.fileTypeExtension == "application/vnd.ms-powerpoint"){
            icon = ppt
            fileTypeExtension = "Powerpoint"

          }

          if(item.fileTypeExtension == "application/msword"){
            icon = word
            fileTypeExtension = "Word"

          }

          if(item.fileTypeExtension == "application/json"){
            icon = json
            fileTypeExtension = "JSON"

          }

          if(item.fileTypeExtension == "text/plain"){
            icon = text
            fileTypeExtension = "Plane Text"
          }
        }



        if (item.keyValues) {

          let isOpen = false

          let folder: any = []

          if(this.folderPath != null && this.folderPath != undefined){
            folder = this.folderPath
          }
          // if(folder != null && folder != undefined){
          //   for(let list of folder){
          //     if(list.clientDocsId == item.clientDocsId && list.name == item.name && list.id == item.id){
          //       isOpen = true
          //     }
          //   }
          // }

            item.key = item.id;
            item.label = item.name;
            item.label = item.name;
            item.icon = icon;
            item.fileTypeExtension = fileTypeExtension
            item.isOpen = isOpen;
            item.children = item.keyValues;

            // Recursively process children
            this.replaceKeyValuesWithChildren(item.children);
        }
    });
  }

  convertArray(mm: any[]): any[] {
    return mm.map(item => this.convertItem(item));
  }

  private convertItem(item: any): any {
    const newItem: any = {
      key: item.key,
      label: item.label,
      data: item.data,
      icon: item.icon,
      clientDocsId: item.clientDocsId,
      children: item.keyValues ? item.keyValues.map((child: any) => this.convertItem(child)) : []
    };

    return newItem;
  }

  getClientDocByClientDocId(clientDocId: any){
    this.generic_service.getClientDocByClientDocId(clientDocId).subscribe(
      (response:any)=>{
        console.log(response);
        // this.singleclientDocData = response.response;
        // this.clientDocsList= [];
        // this.clientDocsList.push(response.response);

      }
    )
  }


  deleteClientDocs(){
    for(let i=0;i<this.clientDocsList.length;i++){
      this.generic_service.deleteClientDocs(this.clientDocsList[i].id).subscribe(
        (response:any)=>{
          console.log(response)
        }
      )
    }
  }

  onChange(event: any) {
    this.file = event.target.files;
    this.uploadingList = []
    this.onUpload(this.file)

  }

  onUpload(file: any) {
    for(let list of file){
      let obj = {
        value: "",
        fileName: list.name,
        fileTypeExtension: list.type,
        isUpload: false
      }
      this.uploadingList.push(
        {
          value: "",
          fileName: list.name,
          fileTypeExtension: list.type,
          severity: "info",
          detail: list.name,
          isUpload: false
        }
      )

      this.generic_service.uploadImage(list).subscribe((event: any) => {

        obj.value = event.response

        this.addFolderOrFile(obj)
      });

    }
    console.log(this.uploadingList)

    this.messages = this.uploadingList
    console.log(this.uploadingList[0])

    // this.reload()
  }
  
  addFileBtn(){
    document.getElementById("add-file-btn")?.click()
    this.type = "file"
  }

  folderPathClick(id: any){
    this.list.key = id
    this.getFolderHierarchyByParentFolderId(this.list)
  }

  getFolderHierarchyByParentFolderIdAfterPost(parentFolderId: any,clientDocsId: any){
    this.isLoading = true

    this.generic_service.getFolderHierarchyByParentFolderId(parentFolderId,clientDocsId).subscribe(
      (response:any)=>{
        this.getFolderPathForGivenFolder(parentFolderId,clientDocsId)

        this.parentFolderId = parentFolderId
        this.clientDocsId = clientDocsId
        console.log(response)

        for(var i=0;i<response.response.length;i++){
          response.response[i].clientDocsId = clientDocsId
        }
        this.clientDocsList = response.response
        console.log(this.clientDocsList)

        if(this.clientDocsList != null && this.clientDocsList != undefined){
          for(var i=0;i<this.clientDocsList.length;i++){
            this.clientDocsList[i].clientDocsId = clientDocsId
          }
  
          this.replaceKeyValuesWithChildren(this.clientDocsList)
        }

        this.isFolderHierarchy = true
        this.isLoading = false


      },
      (error: any) =>{
        console.log(error)
      }
    )
  }  

  checkAccess(access: any){
    let hasAccess: boolean = false
    this.isShowAccess = false
    console.log(access)

    if(access != null && access != undefined && access.length !=0){
      let keys: any = Object.keys(access.access)
      console.log(keys)
      if(keys != null && keys != undefined && keys.length != 0){
        for(let key of keys){
          if(key == sessionStorage.getItem('userId')){
            hasAccess = true
          }
        }
      }
    }

    if(!hasAccess){
      // this.isShowAccess = true
      this.requestFolderOrFileId = access.key
      this.requestClientDocsId = access.clientDocsId
      this.folderOrFileName = access.name
    }else{
      // this.isShowAccess = false
      this.requestFolderOrFileId = ""
      this.requestClientDocsId = ""
      this.folderOrFileName = ""
    }

    return hasAccess
  }

  async getFolderHierarchyByParentFolderId(list: any){
    this.list = list

    let hasAccess: boolean = await this.checkAccess(list)
    console.log(hasAccess)

    if(!hasAccess){
      this.isShowAccess = true
      return
    }else{
      this.isShowAccess = false
    }

    this.isLoading = true


    this.generic_service.getFolderHierarchyByParentFolderId(list.key,list.clientDocsId).subscribe(
      (response:any)=>{
        this.getFolderPathForGivenFolder(list.key,list.clientDocsId)

        this.parentFolderId = list.key
        this.clientDocsId = list.clientDocsId
        console.log(response)

        for(var i=0;i<response.response.length;i++){
          response.response[i].clientDocsId = list.clientDocsId
        }
        this.clientDocsList = response.response
        console.log(this.clientDocsList)

        if(this.clientDocsList != null && this.clientDocsList != undefined){
          for(var i=0;i<this.clientDocsList.length;i++){
            this.clientDocsList[i].clientDocsId = list.clientDocsId
          }
  
          this.replaceKeyValuesWithChildren(this.clientDocsList)
        }

        this.isFolderHierarchy = true
        this.isLoading = false


      },
      (error: any) =>{
        console.log(error)
      }
    )
  }

  closeAccessMessage(){
    this.isShowAccess = false;
    this.requestFolderOrFileId = ""
    this.requestClientDocsId = ""
    this.folderOrFileName = ""
  }

  accessPrivilegesRequest(){
    let body = {
      "requestedBy": sessionStorage.getItem('userName'),
      "access": {
        "validFrom": new Date().getTime(),
        "id": Number(this.userId),
        "validTo": 4102358400000,
        "name": sessionStorage.getItem('userName')
      },
      "clientDocsId": Number(this.requestClientDocsId),
      "folderOrFileId": String(this.requestFolderOrFileId),
      "folderOrFileName": this.folderOrFileName,

      "cid": Number(this.cid),
    }
    console.log(body)
    this.generic_service.addAccessPrivilegesRequest(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.toastr.success('Request Send')
        this.closeAccessMessage()
      },
      (err:any)=> {
        console.log(err)
      }
    ) 
  }

  refreshGetFolderHierarchyByParentFolderId(parentFolderId: any,clientDocsId: any){
    console.log(parentFolderId)
    console.log(clientDocsId)
    this.generic_service.getFolderHierarchyByParentFolderId(parentFolderId,clientDocsId).subscribe(
      (response:any)=>{
        // this.parentFolderId = parentFolderId
        // this.clientDocsId = clientDocsId
        // console.log(response)
        // for(var i=0;i<response.response.length;i++){
        //   response.response[i].clientDocsId = clientDocsId
        // }
        // this.folderHierarchy = response.response
        // this.isFolderHierarchy = true

      },
      (error: any) =>{
        console.log(error)
      }
    )
  }

  getFolderPathForGivenFolder(parentFolderId: any,clientDocsId: any){
    this.generic_service.getFolderPathForGivenFolder(parentFolderId,clientDocsId).subscribe(
      (response:any)=>{
        for(let list of response.response){
          list.clientDocsId = clientDocsId
        }
        console.log(response)

        this.folderPath = response.response

        for(let list of this.folderPath){
          if(list.structureType != null && list.structureType != undefined && list.structureType != ""){
            this.peresentStructureType = list.structureType

            let company = "bi bi-building"
            let location = "bi bi-geo-alt"
            let department = "bi bi-houses"
            let icon = ""
            if(list.structureType == 'company'){
              icon = company
            }
            if(list.structureType == 'location'){
              icon = location
            }
            if(list.structureType == 'department'){
              icon = department
            }
            list.icon = icon
          }else{
            list.icon = ""

          }

        }

        console.log(this.structureType)
        console.log(this.folderPath)
      },
      (error: any) =>{
        console.log(error)
      }
    )
  }

  

  checkImageType(type: any){
    if(type.includes('image')){
      return true
    }else{
      return false
    }
  }

  checkFileTypeExtension(type: any){
    if(!type.includes('image')){
      return true
    }else{
      return false
    }
  }





  cl(){
    console.log('click')
  }

  @Input() position = { x: 0, y: 0 };
  @Input() openPosition = { x: 0, y: 0 };
  @Input() leftPosition = { x: 0, y: 0 };
  
  visible = false;
  parent = false;
  type1 = ''
  listClientId : any
  listId : any
  show(x: number, y: number): void {
    this.position = { x, y };
    this.visible = true;
  }

  openShow(x: number, y: number): void {
    this.openPosition = { x, y };
    this.openSpaceVisible = true;
  }

  showLeftMenu(x: number, y: number): void {
    this.leftPosition = { x, y };
    this.leftMenuVisible = true;
  }


  hide(): void {
    this.visible = false;
    this.parent = false;
    this.openSpaceVisible = false;
    this.leftMenuVisible = false
    this.type1 = ""
  }

  structureType = ""
  peresentStructureType: any = ""
  isCompany: any = false
  isLocation: any = false
  isDepartment: any = false

  onOptionSelected(option: string): void {
    console.log('Selected option:', option);
    this.hide();
    if(option == "folder"){
      this.type = "folder"
    }
    if(option == "New Company Folder"){
      this.structureType = "company"
      this.type = "folder"

    }
    if(option == "New Location Folder"){
      this.structureType = "location"
      this.type = "folder"

    }
    if(option == "New Department Folder"){
      this.structureType = "department"
      this.type = "folder"

    }
 
    if(option == "file"){
      this.type = "file"
      this.addFileBtn()
    }

    if(option == "copy"){
      console.log('copied')
      this.isCopied = true
      this.copiedData = []
      this.copiedData.push(this.rightClickedData)
      console.log(this.copiedData)
      this.copyFromId = this.copiedData[0].key
    }

    if(option == "paste"){
      console.log('paste')

      console.log(this.copiedData)
      console.log(this.rightClickedData)
      this.copyToId = this.rightClickedData.key
      this.toClientDocsId = this.rightClickedData.clientDocsId
      this.copyClientDocs()
    }

    if(option == "move"){
      this.isMove = true
      this.moveData = []
      this.moveData.push(this.rightClickedData)
      console.log(this.moveData)
      this.moveFromId = this.moveData[0].key
    }

    if(option == "moveTo"){
      console.log(this.moveData)
      this.moveToId = this.rightClickedData.key
      this.moveClientDocs()
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.hide();
    }
    this.hide();

  }

  onOpenClick(event: MouseEvent){
    console.log('open click')
    this.visible = false;
    this.parent = false;
    this.isDepartment = false
    this.isLocation = false
    this.isCompany = false
    if(this.peresentStructureType != ''){
      if(this.peresentStructureType == "company"){
        this.isDepartment = false
        this.isLocation = true
        this.isCompany = false
      }
      if(this.peresentStructureType == "location"){
        this.isDepartment = true
        this.isLocation = false
        this.isCompany = false
      }
      if(this.peresentStructureType == "department"){
        this.isDepartment = false
        this.isLocation = false
        this.isCompany = false
      }
    }else{
      this.isCompany = true
    }
    console.log(this.isCompany)
    console.log(this.isLocation)
    console.log(this.isDepartment)
    console.log(this.peresentStructureType)
    event.preventDefault();
    this.openShow(event.offsetX+280, event.pageY-70);
  }

  onLeftClick(event: MouseEvent,list: any){
    console.log('open click')
    this.visible = false;
    this.parent = false;
    this.openSpaceVisible = false;
    this.leftClickedData = []
    this.leftClickedData = list
    console.log(this.leftClickedData)
    this.rightClickedData = []
    this.rightClickedData = list

    // console.log(list)
    this.fileOrFolderName = list.name
    this.type1 = list
    this.clientDocsId = list.clientDocsId
    this.parentFolderId = list.key
    event.preventDefault();
    this.showLeftMenu(event.offsetX+40, event.pageY-70);
  }

  onRightClick(event: MouseEvent,list: any): void {

    event.stopPropagation()
    this.parent = false;
    this.openSpaceVisible = false;
    console.log('right click')
    console.log(list)
    this.rightClickedData = []
    this.rightClickedData = list

    // console.log(list)
    this.fileOrFolderName = list.name
    this.type1 = list
    this.clientDocsId = list.clientDocsId
    this.parentFolderId = list.key
    // this.rightClientDocsId = list.clientDocsId
    // this.rightParentFolderId = list.key
    this.menuOptionsType = list.fileType

    console.log(this.clientDocsId)
    console.log(this.parentFolderId)
    console.log(this.copyFromId)
    console.log(this.moveFromId)

    event.preventDefault();
    this.show(event.offsetX+280, event.pageY-70);
  }


clientDocRename(){
  if(this.fileOrFolderName == ""){
    this.toastr.warning('File or Folder cannot be empty')
  }
  let body = {
    "version": 0,
    "isActive": true,
    "description": "",
    "clientDocsId": this.clientDocsId,
    "name": this.fileOrFolderName,
    "id": this.parentFolderId,
    "cid": Number(this.cid)
  }
  console.log(body)
  this.generic_service.clientDocsRename(body).subscribe(
    (res:any)=>{
      console.log(res)
      this.toastr.success("Successfully Renamed")
      let folder = this.folderPath[this.folderPath.length - 1]
      console.log(folder)
      // this.getFolderHierarchyByParentFolderId(folder.id,folder.clientDocsId)
      this.getFolderHierarchyByParentFolderIdAfterPost(this.parentFolderId,this.clientDocsId)

      // this.getAllClientDocs(this.pageNumber,this.recordsPerPage)

      // this.reload()
      this.modalClose()
    },
    (err:any)=> {
      console.log(err)
      this.toastr.error(err.errors[0].description)
    }
  )
}

deleteSubfolder(){
  this.generic_service.deleteSubfolder(this.clientDocsId,this.parentFolderId).subscribe(
    (res:any)=>{
      console.log(res)
      this.toastr.success("Successfully Deleted")
      // this.getAllClientDocs(this.pageNumber,this.recordsPerPage)
      this.modalClose()

    },
    (err:any)=> {
      console.log(err)
      this.toastr.error(err.errors[0].description)
    }
  )
}

allClientDocsAtZeroLevel(){
  this.generic_service.allClientDocsAtZeroLevel().subscribe(
    (response:any)=>{
      console.log(response)

      let folder: any = []

      for(let list of response.response){
        list.list[0].clientDocsId = list.clientId
        folder.push(list.list[0])
      }
        this.clientDocsList = folder;
        console.log(this.clientDocsList)

        let menus: any = folder;

        this.replaceKeyValuesWithChildren(menus)
        console.log(this.clientDocsList)
        console.log(menus)
        this.data = menus;

      // let menus: any = []
      // for(let list of folder){
      //   let obj: any = {
      //     key: list.clientId,
      //     label: list.name,
      //     data: list.name,
      //     icon: 'pi pi-folder',
      //     children: [],
      //     clientId: 3,
      //     fileType: "folder",
      //     fileTypeExtension: null,
      //     id: null,
      //     keyValues: [],
      //     name: "test 3",
      //     value: ""
      //   }
      //   menus.push(obj)
      // }
      // console.log(folder)
      // console.log(menus)
      // this.data = menus
      // console.log(this.data)


    },
    (err:any)=> {
      console.log(err)
    }
  )
}


getFolder(parentFolderId: any,clientDocsId: any){
  console.log(parentFolderId)
  console.log(clientDocsId)
  // this.generic_service.getFolderHierarchyByParentFolderId(parentFolderId,clientDocsId).subscribe(
  //   (response:any)=>{
  //     console.log(response)
  //   },
  //   (error: any) =>{
  //     console.log(error)
  //   }
  // )
}


convertData(data: Tree[]): Tree[] {
  const convert = (nodes: Tree[], parentKey: string = '0'): Tree[] => {
    return nodes.map((node, index) => {
      const newKey = `${parentKey}-${index}`;
      const convertedNode: Tree = {
        key: newKey,
        label: node.label,
        data: node.data,
        icon: node.icon,
        clientDocsId: node.clientDocsId,
        fileType: node.fileType,
        fileTypeExtension: node.fileTypeExtension,
        id: node.id,
        name: node.name,
        value: node.value,
        children: node.keyValues ? convert(node.keyValues, newKey) : []
      };
      return convertedNode;
    });
  };

  return convert(data);
}

ok(data: any){
  console.log(data)
}
selectedFile!: any;

unselectFile() {
  this.selectedFile = null;
}

nodeExpand(event: any) {
  console.log(event)
}

nodeCollapse(event: any) {
  console.log(event)
}

// nodeSelect(event: any) {
//   console.log(event)
//   console.log(event.node)
//   this.getFolderHierarchyByParentFolderId(event.node.key,event.node.clientDocsId)
// }

nodeUnselect(event: any) {
  console.log(event)
}

// openFolder(list: any){
//   console.log(list)
//   if(list.children != null && list.children != undefined && list.children.length != 0){
//     list.isOpen = !list.isOpen
//   }
// }

subMenu(){
  let p = '<div class="sub-folder" *ngIf="list.isOpen && (list.children != null && list.children != undefined && list.children.length != 0)"><div class="sub-folder-name" *ngFor="let subFolder of list.children;let i = index"><div class="border-line"><p class="line"></p></div><i class="bi bi-folder-fill"></i><p class="name">{{subFolder.label}}</p></div></div>'
  return p
}

onResizeStart(event: any){
  console.log(event)
}

onResizeEnd(event: any){
  console.log(event)
}

  item: any;
  toggleFolder(item: any) {
    console.log(item)
    this.item = item
    if(item.fileType == "Folder"){
      item.isOpen = !item.isOpen;
    }
  }

  openFolder(item: any) {

    console.log(item)
    if(item.fileType == "Folder"){
      item.isOpen = !item.isOpen;
      // if(item.isOpen == false){
      //   item.children = [];
      // }else{

      // }

      // this.getFolderHierarchyByParentFolderId(item)
      this.getFolderHierarchyByParentFolderIdAfterPost(item.key,item.clientDocsId)
      this.generic_service.getFolderHierarchyByParentFolderId(item.key,item.clientDocsId).subscribe(
        (response:any)=>{
          console.log(response)


        // for(var i=0;i<response.response.length;i++){
        //   response.response[i].clientDocsId = item.clientDocsId
        // }

        if(response.response != null && response.response != undefined){
          for(var i=0;i<response.response.length;i++){
            response.response[i].clientDocsId = item.clientDocsId
          }
  
          this.replaceKeyValuesWithChildren(response.response)
          console.log(response.response)
          item.children = response.response;
          console.log(item)
        }
        console.log(response)  
        },
        (error: any) =>{
          console.log(error)
        }
      )


      console.log(item)

    }
  }

  getFolderClildrens(parentFolderId: any,clientDocsId: any){
    console.log(parentFolderId)
    console.log(clientDocsId)

  }


  // refreshFolder(pageNumber:any,recordsPerPage:any){
  //   this.generic_service.getAllClientDocs(pageNumber,recordsPerPage).subscribe(
  //     (response:any)=>{
  //       let folder: any = []
  //       for(let list of response.response.clientDocsList){
  //         list.keyValues[0].clientDocsId = list.clientDocsId
  //         console.log(list)
  //         folder.push(list.keyValues[0])
  //       }
  //       let menus: any = []
  //       for(let list of folder){
  //         let obj: any = {
  //           clientDocsId: list.clientDocsId,
  //           id: list.id,
  //           name: list.name,
  //           value: list.value,
  //           fileType: list.fileType,
  //           fileTypeExtension: list.fileTypeExtension,
  //           keyValues: list.keyValues
  //         }
  //         menus.push(obj)
  //       }
 
  //       this.replaceKeyValuesWithChildren(menus)
  //       this.data = menus;
  //       console.log(this.item)

  //     }
  //   )
  // }

  moveClientDocs(){
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "fromClientDocsId": this.moveData[0].clientDocsId,
      "toClientDocsId": this.toClientDocsId,
      "fromId": String(this.moveFromId),
      "toId": String(this.moveToId),
      "cid": Number(this.cid)
    }

    console.log(body)
    this.generic_service.moveClientDocs(body).subscribe(
      (res:any)=>{
        console.log(res)
        this.moveFromId =  ""
        this.moveToId =  ""
        this.moveData = []
        this.toastr.success('copied success')

      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  copyClientDocs(){
    if(this.copyToId == ""){

    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "fromClientDocsId": this.copiedData[0].clientDocsId,
      "toClientDocsId": this.toClientDocsId,
      "fromId": this.copyFromId,
      "toId": this.copyToId,
      "cid": Number(this.cid)
    }

    console.log(body)
    this.generic_service.copyClientDocs(body).subscribe(
      (res:any)=>{
        console.log(res)
        this.copyFromId =  ""
        this.copyToId =  ""
        this.copiedData = []
        this.toastr.success('copied success')
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }






  fileUrl: string = 'https://example.com/path/to/your/file';
  fileType: string = 'pdf';  // Change based on the file type you expect


  viewFile(): void {
    // For PDFs and images, open in a new tab
    const fileUrl = this.rightClickedData.value;
    const fileType = this.fileType;

    this.openFileInNewTab(fileUrl)
    
    // if (fileType === 'pdf') {
    //   // For PDFs, open in a new tab
    //   window.open(fileUrl, '_blank');
    // } else if (fileType === 'image') {
    //   // For images, open in a new tab
    //   window.open(fileUrl, '_blank');
    // } else {
    //   // Handle other file types or show a download link
    //   window.open(fileUrl, '_blank');
    // }
    // window.open(fileUrl, '_blank');

  }

  clearMessage() {
    this.messageService.clear();
  }

  getAllCompanyProfileWithoutPagination(){
    this.generic_service.getAllCompanyProfileWithoutPagination().subscribe(
      (response:any)=>{
        console.log(response)
        this.companyData = response.response
      },
      (err:any)=> {
        console.log(err)
      }
    ) 
  }

  getAllLocation(){
    this.generic_service.getAllLocation().subscribe(
      (response:any)=>{
        console.log(response)
        this.locationData = response.response
      },
      (err:any)=> {
        console.log(err)
      }
    ) 
  }

  getAllIndustry(){
    this.generic_service.getAllIndustry().subscribe(
      (response:any)=>{
        console.log(response)
        this.industryData = response.response
      },
      (err:any)=> {
        console.log(err)
      }
    ) 
  }  



  // Function to open the file in a new tab
  openFileInNewTab(fileUrl: any): void {
    window.open(fileUrl, '_blank');
  }

}